import { SessionStatusBadge } from '@avanta/shared/components/SessionStatusBadge';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { t } from '@avanta/shared/i18n';
import { type TableFilterOption, type TableColumnFilterConfig } from '@avanta/shared/types/table';
import {
  getSessionStatusFromEnterpriseStatus,
  getSessionStatusLabel,
} from '@avanta/shared/utils/appointments';
import {
  ENTERPRISE_APPOINTMENT_STATUS,
  UPCOMING_APPOINTMENT_STATUSES,
} from 'constants/appointments';
import { EMPTY_VALUE } from 'constants/common';
import { type EnterpriseAppointmentStatus } from 'types/appointments';
import { type PatientListFilterKey } from './useFetchInsuredUsers';

export const getEmployeeSessionStatusBadge = (
  status?: EnterpriseAppointmentStatus | null
): React.ReactElement => {
  if (!status || !UPCOMING_APPOINTMENT_STATUSES.has(status)) {
    return <span className="text-gray-400">{EMPTY_VALUE}</span>;
  }

  const sessionStatus = getSessionStatusFromEnterpriseStatus(status);

  return (
    <SessionStatusBadge status={sessionStatus}>
      {getSessionStatusLabel(sessionStatus)}
    </SessionStatusBadge>
  );
};

export const getSessionFilterOptions = (): TableFilterOption<PatientListFilterKey>[] => [
  {
    key: 'withSession',
    label: t('InsuredPersonsList.filters.withSession', { ns: LOCIZE_NS.INSURANCE }),
  },
  {
    key: 'withoutSession',
    label: t('InsuredPersonsList.filters.withoutSession', { ns: LOCIZE_NS.INSURANCE }),
  },
  {
    key: 'withoutFile',
    label: t('InsuredPersonsList.filters.withoutRecord', { ns: LOCIZE_NS.INSURANCE }),
  },
];

export const getSessionStatusColumnFilter = (): TableColumnFilterConfig => ({
  allLabel: t('InsuredPersonsList.filters.all', { ns: LOCIZE_NS.INSURANCE }),
  options: [
    {
      value: ENTERPRISE_APPOINTMENT_STATUS.PENDING,
      label: t('AppointmentCard.states.pending', { ns: LOCIZE_NS.APPOINTMENTS }),
    },
    {
      value: ENTERPRISE_APPOINTMENT_STATUS.SCHEDULED,
      label: t('AppointmentCard.states.scheduled', { ns: LOCIZE_NS.APPOINTMENTS }),
    },
    {
      value: ENTERPRISE_APPOINTMENT_STATUS.CONFIRMED,
      label: t('AppointmentCard.states.confirmed', { ns: LOCIZE_NS.APPOINTMENTS }),
    },
  ],
});
